import { InsuranceCardsSection } from "@/features/patient/insurance/components/InsuranceCardsView";
import { adaptCoverage } from "@/features/patient/dashboard/utils/adaptInsurance";
import { useParsedRecords } from "@/portals/patient/context/ParsedRecordsContext";

export function InsuranceCardsPage() {
  const { records, isLoading } = useParsedRecords();

  const coverageRecords = records.filter((r) => r.resourceType === "Coverage").map(adaptCoverage);
  const coverage = coverageRecords.find((c) => c.isActive) ?? coverageRecords[0];

  return <InsuranceCardsSection coverage={coverage} isLoading={isLoading} />;
}
